export type DataElementType = {
  value: string;
  label?: string;
  group: DataKeysEnum;
  inputLabel?: string;
  inputCryptoLabel?: string;
  inputFiatLabel?: string;
  newCard?: boolean;
  fullname?: string;
  additionalData?: string;
};

export enum DataKeysEnum {
  cards = 'cards',
  my_wallets = 'my_wallets',
  blockchain_wallets = 'blockchain_wallets',
  my_accounts = 'my_accounts',
  transfers = 'transfers',
}

export type DataType = { key: DataKeysEnum; list: DataElementType[] }[];

export type InputKeys = 'left' | 'right';

export type BaseInputType = {
  element?: DataElementType;
  label: string;
};

export type StateType = {
  [key in InputKeys]: BaseInputType & { data: DataType };
} & { active?: InputKeys };
